/**
 * Minimal fallback for lazy HomePage. Shows LCP hero on desktop only.
 * Mobile HomePage does not show the top marketing banner image — showing it here
 * caused a visible flash of the old/wrong banner on every refresh before the real page mounted.
 */
import React from 'react';

const MOBILE_GRADIENT =
  'linear-gradient(90deg, #4a148c 0%, #2d1b4e 25%, #1a1a1a 50%, #0d0d0d 75%, #000000 100%)';

const HomePageFallback: React.FC = () => (
  <>
    {/* Mobile: match real HomePage chrome (white nav strip + gradient) — no hero PNG */}
    <div className="flex md:hidden flex-col min-h-screen w-full">
      <div className="h-14 w-full shrink-0 bg-white border-b border-gray-200" aria-hidden />
      <div
        className="flex flex-1 flex-col items-center justify-center px-4 pb-24"
        style={{ background: MOBILE_GRADIENT }}
      >
        <div
          className="h-8 w-8 shrink-0 rounded-full border-2 border-orange-500 border-t-transparent animate-spin"
          aria-hidden
        />
        <p className="mt-4 text-sm text-white/70">Loading…</p>
      </div>
    </div>

    {/* Desktop hero — LCP candidate (unchanged) */}
    <section
      className="main-thread-contain relative z-10 hidden w-full items-center justify-center md:flex md:pt-2 lg:pt-3"
      style={{ marginTop: 0, marginBottom: 0 }}
    >
      <div className="relative w-full flex justify-center overflow-hidden" style={{ aspectRatio: '1920/700', maxHeight: 700 }}>
        <img
          src="/images/hero-stringpak-purple.png"
          alt="StringPak premium guitar strings hero"
          width={1920}
          height={700}
          fetchPriority="high"
          decoding="async"
          className="block h-full w-full object-contain object-center m-[5px]"
        />
      </div>
    </section>
    {/* Desktop loading row */}
    <div
      className="main-thread-contain hidden min-h-[200px] items-center justify-center py-12 md:flex"
      style={{ contain: 'layout style' }}
    >
      <div
        className="h-8 w-8 rounded-full border-2 border-orange-500 border-t-transparent animate-spin"
        aria-hidden
      />
    </div>
  </>
);

export default HomePageFallback;
